import "./postdetail.css";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import Loader from "../../components/loader/Loader";
import { Deletepost } from "../deletepost/Deletepost";
import { PostAuthor } from "../../components/posts/PostAuthor";
import { Link, useParams } from "react-router-dom";
import { Post } from "../forum/Forum";
import LikeButton from "../../components/likeButton/LikeButton";
import axios from "axios";
import { delay } from "../../modules/setTimeout";
import dummy_full_post from "../../dummy_data/post_full.json";
import { IoMdCopy } from "react-icons/io";
export const Postdetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState<Post | null>(null);
  const [creatorDetails, setCreatorDetails] = useState<any>(null); // State for user details
  const [error, setError] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [playerLink, setPlayerLink] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  const { currentUser } = useContext(UserContext);

  useEffect(() => {
    const getPost = async () => {
      setIsLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/posts/${id}`
    );
    setPost(response.data);
    setPlayerLink(response.data.playerLink || null);


const creatorId =
  typeof response.data.creator === "string"
    ? response.data.creator
    : response.data.creator?._id;

if (creatorId) {
  const creatorResponse = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/users/${creatorId}`
  );
  setCreatorDetails(creatorResponse.data);
}


  } catch (error) {
    setError(error);
    console.error("Error fetching post data:", error);
  }
  setIsLoading(false);
};
    getPost();
  }, []);

  const handleShareClick = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="post-detail">
      {error && <p className="error">{error}</p>}
      {post && (
        <div className="container post-detail__container">
          <div className="post-detail__header">
            {post.creator && post.createdAt && creatorDetails && (
              <PostAuthor
                playerID={creatorDetails._id}  
                createdAt={post.createdAt}
                avatar={creatorDetails.avatar ?? ""} 
                name={creatorDetails.name ?? "Unknown User"} 
              />
            )}
            {post.creator &&
              currentUser?.userId === post.creator.toString() && (
                <div className="post-detail__buttons">
                  <Link
                    to={`../posts/${post._id}/edit`}
                    className="btn sm primary"
                  >
                    Edit
                  </Link>
                  <Deletepost postId={id} />
                </div>
              )}
            <div className="share">
              <button className="btn sm" id="share" onClick={handleShareClick}>
                <IoMdCopy />
              </button>
              {copied && <span className="copied-message">Copied Link</span>}
            </div>
            {currentUser && (
              <div className="post-detail__action-buttons">
                <LikeButton
                  postId={id || ""}
                  currentUser={currentUser}
                  className="post-detail__like-button"
                  onLikeChange={(updatedLikes: string[]) => {
                    setPost((prev) => prev ? { ...prev, likes: updatedLikes } : prev);
                  }}
                />
                <span className="like-count">
                  {post.likes?.length || 0} Like{post.likes?.length === 1 ? "" : "s"}
                </span>
              </div>
            )}
          </div>
          <h1 className="title">{post.title}</h1>
          <div className="post-detail__thumbnail">
            <img src={post?.thumbnail} alt="Blog Picture" />
          </div>

          <p dangerouslySetInnerHTML={{ __html: post.description }}></p>
          {playerLink !== null && (
            <div className="post-detail__player-link">
              <h3>
                <strong>
                  <a
                    className="post__title"
                    href={playerLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {playerLink}
                  </a>
                </strong>
              </h3>
            </div>
          )}
        </div>
      )}
    </section>
  );
};
